import React from 'react';

export default function AppLogo() {
    return <div>
        <img alt='Logo' src={`${process.env.PUBLIC_URL + '/logoInfoSystem.png'}`}></img>
    </div>
}